import { z } from "zod"

export const updateMultipleChoiceSchema = z.object({
  question: z
    .string({
      required_error: "La pregunta es requerida",
    })
    .min(1, { message: "La pregunta es requerida" }),
  options: z
    .array(
      z.object({
        text: z.string().min(1, { message: "La opción no puede estar vacía" }),
        isCorrect: z.boolean().default(false),
      }),
    )
    .min(2, { message: "Debe haber al menos 2 opciones" })
    .max(4, { message: `No puede haber más de ${4} opciones` })
    .refine((options) => options.some((option) => option.isCorrect), {
      message: "Debe seleccionar al menos una opción correcta",
    }),
})

export type UpdateMultipleChoiceFormValues = z.infer<typeof updateMultipleChoiceSchema>
